var map = {
	"./cn": [
		"./src/translations/cn.json",
		0
	],
	"./cn.json": [
		"./src/translations/cn.json",
		0
	],
	"./cs": [
		"./src/translations/cs.json",
		1
	],
	"./cs.json": [
		"./src/translations/cs.json",
		1
	],
	"./de": [
		"./src/translations/de.json",
		2
	],
	"./de.json": [
		"./src/translations/de.json",
		2
	],
	"./dk": [
		"./src/translations/dk.json",
		3
	],
	"./dk.json": [
		"./src/translations/dk.json",
		3
	],
	"./el": [
		"./src/translations/el.json",
		4
	],
	"./el.json": [
		"./src/translations/el.json",
		4
	],
	"./en": [
		"./src/translations/en.json"
	],
	"./en.json": [
		"./src/translations/en.json"
	],
	"./es": [
		"./src/translations/es.json",
		5
	],
	"./es.json": [
		"./src/translations/es.json",
		5
	],
	"./fr": [
		"./src/translations/fr.json",
		6
	],
	"./fr.json": [
		"./src/translations/fr.json",
		6
	],
	"./hi": [
		"./src/translations/hi.json",
		7
	],
	"./hi.json": [
		"./src/translations/hi.json",
		7
	],
	"./hr": [
		"./src/translations/hr.json",
		8
	],
	"./hr.json": [
		"./src/translations/hr.json",
		8
	],
	"./hu": [
		"./src/translations/hu.json",
		9
	],
	"./hu.json": [
		"./src/translations/hu.json",
		9
	],
	"./it": [
		"./src/translations/it.json",
		10
	],
	"./it.json": [
		"./src/translations/it.json",
		10
	],
	"./ja": [
		"./src/translations/ja.json",
		11
	],
	"./ja.json": [
		"./src/translations/ja.json",
		11
	],
	"./kk": [
		"./src/translations/kk.json",
		12
	],
	"./kk.json": [
		"./src/translations/kk.json",
		12
	],
	"./lv": [
		"./src/translations/lv.json",
		13
	],
	"./lv.json": [
		"./src/translations/lv.json",
		13
	],
	"./nb": [
		"./src/translations/nb.json",
		14
	],
	"./nb.json": [
		"./src/translations/nb.json",
		14
	],
	"./pl": [
		"./src/translations/pl.json",
		15
	],
	"./pl.json": [
		"./src/translations/pl.json",
		15
	],
	"./pt": [
		"./src/translations/pt.json",
		16
	],
	"./pt.json": [
		"./src/translations/pt.json",
		16
	],
	"./ro": [
		"./src/translations/ro.json",
		17
	],
	"./ro.json": [
		"./src/translations/ro.json",
		17
	],
	"./ru": [
		"./src/translations/ru.json",
		18
	],
	"./ru.json": [
		"./src/translations/ru.json",
		18
	],
	"./tr": [
		"./src/translations/tr.json",
		19
	],
	"./tr.json": [
		"./src/translations/tr.json",
		19
	],
	"./tw": [
		"./src/translations/tw.json",
		20
	],
	"./tw.json": [
		"./src/translations/tw.json",
		20
	],
	"./uk": [
		"./src/translations/uk.json",
		21
	],
	"./uk.json": [
		"./src/translations/uk.json",
		21
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/translations lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;